module.exports = __webpack_public_path__ + "static/img/2-1.a590058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-1.jpg
// module id = 728
// module chunks = 1